import request from "@/plugins/axios"
//发票板式文件审核
let prefix = "eids-invoice/risk";

export function ayalysis(criteria) {
  return request({
    url: prefix + '/analysis',
    method: 'post',
    data: criteria,
  })
}

export function pageList(criteria) {
  return request({
    url: prefix + '/pagelist',
    method: 'post',
    data: criteria,
  })
}
